import { useCallback } from "react"
import { notification } from "components/common"
import { t } from "i18next"

export function usePaymentProofUploadHandler({ fullPath, form, ocrEnabled, paymentModesMap, getDataFromImage }) {
  return useCallback(
    data => {
      const attachmentTypeIdForOcr = data?.imageData?.attachmentTypeId ?? data?.attachmentTypeId ?? 1
      const mergedImageData = data?.imageData
        ? {
            ...data.imageData,
            attachmentTypeId: data.imageData?.attachmentTypeId ?? attachmentTypeIdForOcr,
          }
        : data?.imageData

      if (data?.imageData && ocrEnabled) {
        form.setFieldValue([...fullPath, "ocrData"], null)
        form.setFieldValue([...fullPath, "buyerFee"], false)
        const extraField = paymentModesMap?.[data?.imageData?.paymentModeKey]?.extraFields
        if (extraField?.["bank_deposit_slip"]) {
          notification.info({
            message: `${t("Payment of type")} ${data?.imageData?.paymentMode} ${t(
              "detected. Please upload deposit slip as well."
            )}`,
          })
        }
        getDataFromImage({
          attachmentTypeId: attachmentTypeIdForOcr,
          file: data?.url,
          name: data?.name,
          projectId: data?.projectId,
          detectPaymentMode: false,
        })
          .unwrap()
          .then(parsedData => {
            const isAgency =
              parsedData?.imageData?.indicatesBayutServiceFee ||
              parsedData?.projectBankAccountMatch?.matchedAccountEntityType === "agency"
            form.setFieldValue([...fullPath, "ocrData"], parsedData)
            form.setFieldValue([...fullPath, "buyerFee"], isAgency)
            const key = parsedData?.imageData?.paymentModeKey
            if (key) form.setFieldValue([...fullPath, "modeOfPayment"], key)
          })
          .catch(error => notification?.error({ message: error?.message }))
      }

      form.setFieldValue([...fullPath, "paymentProof"], {
        ...data,
        attachmentTypeId: attachmentTypeIdForOcr,
        imageData: mergedImageData,
      })
      form.setFieldValue([...fullPath, "modeOfPayment"], data?.imageData?.paymentModeKey || null)
      if (!ocrEnabled) form.setFieldValue([...fullPath, "ocrData"], null)
    },
    [fullPath, form, ocrEnabled, paymentModesMap, getDataFromImage]
  )
}
